import React from "react";
import dayjs from "dayjs";
import { message } from "antd";
import CgIcon from "../common/CgIcon";
import {
  Board,
  HeroBand,
  BoardCard,
  BoardColumns,
  BoardColumn,
} from "../Dashboard/BoardParts";
import { queueIcon } from "../Dashboard/boardIcons";
import { formatMoney } from "../common/money";
import {
  SAMPLE_ANALYTICS,
  SAMPLE_CATEGORY_SPLIT,
  SAMPLE_STOCK_HEALTH,
  SAMPLE_REPORTS,
} from "../Dashboard/boardSampleData";
import styles from "../Dashboard/pharmacyBoard.module.css";

const inr0 = (value) =>
  formatMoney(Math.round(Number(value) || 0)).replace(".00", "");


const PharmacyAnalytics = () => {
  const a = SAMPLE_ANALYTICS;
  const net = a.salesBilled - a.salesReturns;
  const stockTotal =
    SAMPLE_STOCK_HEALTH.reduce((sum, s) => sum + s.count, 0) || 1;

  const notYetAvailable = (label) =>
    message.info(`${label} needs a reporting endpoint - not available yet.`);

  return (
    <Board>
      <HeroBand
        kicker={`${a.period} · ${dayjs().startOf("month").format("DD")} – ${dayjs()
          .endOf("month")
          .format("DD MMMM YYYY")}`}
        headline={`${inr0(net)} net of returns`}
        sub={`${a.billCount} bills · ${a.purchaseOrderCount} purchase orders · ${a.returnCount} returns across both ledgers`}
        actions={[
          {
            label: "Export Workbook",
            icon: <CgIcon name="download" size={16} stroke={2} />,
            solid: true,
            onClick: () => notYetAvailable("Workbook export"),
          },
          /* The same two glyphs the reports below carry, so a button and the
             card it stands for are recognisably the same thing. */
          {
            label: "Sales Register",
            icon: <CgIcon name="coins" size={16} stroke={2} />,
            onClick: () => notYetAvailable("Sales Register"),
          },
          {
            label: "Stock Ledger",
            icon: <CgIcon name="services" size={16} stroke={2} />,
            onClick: () => notYetAvailable("Stock Ledger"),
          },
        ]}
        metrics={[
          { label: "Sales Billed", value: inr0(a.salesBilled) },
          { label: "Purchase Ordered", value: inr0(a.purchaseOrdered) },
          { label: "Sales Returns", value: inr0(a.salesReturns) },
          { label: "Purchase Returns", value: inr0(a.purchaseReturns) },
        ]}
      />

      <BoardColumns>
        <BoardColumn>
          <BoardCard title="Sales by Category">
            <div className={styles.catWrap}>
              {SAMPLE_CATEGORY_SPLIT.map((c) => (
                <div className={styles.catRow} key={c.label}>
                  <span className={styles.catDot} style={{ background: c.color }} />
                  <span className={styles.catName}>{c.label}</span>
                  <span className={styles.catBar}>
                    <i style={{ width: `${c.percent}%`, background: c.color }} />
                  </span>
                  <span className={styles.catPct}>{c.percent}%</span>
                </div>
              ))}
            </div>
          </BoardCard>
        </BoardColumn>

        <BoardColumn>
          <BoardCard title="Stock Health">
            <div className={styles.catWrap}>
              {SAMPLE_STOCK_HEALTH.map((s) => (
                <div className={styles.catRow} key={s.label}>
                  <span className={styles.catDot} style={{ background: s.color }} />
                  <span className={styles.catName}>{s.label}</span>
                  <span className={styles.catBar}>
                    <i
                      style={{
                        width: `${Math.round((s.count / stockTotal) * 100)}%`,
                        background: s.color,
                      }}
                    />
                  </span>
                  <span className={styles.catPct}>{s.count}</span>
                </div>
              ))}
            </div>
          </BoardCard>
        </BoardColumn>
      </BoardColumns>

      <BoardCard title="Reports" count={SAMPLE_REPORTS.length}>
        <div className={styles.repGrid}>
          {SAMPLE_REPORTS.map((r) => (
            <button
              key={r.key}
              type="button"
              className={styles.repCard}
              onClick={() => notYetAvailable(r.label)}
            >
              <span className={styles.repIco}>{queueIcon(r.icon)}</span>
              <span className={styles.repT}>
                <b>{r.label}</b>
                <i>{r.note}</i>
              </span>
              <span className={styles.repGo}>
                <CgIcon name="download" size={15} stroke={2} />
              </span>
            </button>
          ))}
        </div>
      </BoardCard>
    </Board>
  );
};

export default PharmacyAnalytics;
